module.exports = __webpack_public_path__ + "img/MANA.b717b6f5.svg";